// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export const getInstIdentifierKey = (id: string, source: string) => {
  const idLength = id.length;
  const sourceLength = source.length;
  return idLength + id + sourceLength + source;
};
